import styled from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const BlockedCategorySelectWrapper = styled.div``

export const AddBlockedCategoryButton = styled.button`
  background: rgba(0, 92, 217, 0.3);
  border: none;
  border-radius: 12px;
  display: inline-block;
  height: 34px;
  vertical-align: middle;
  width: 36px;
  margin-left: 0.7rem;
  &:hover {
    background: rgba(0, 92, 217, 0.2)
      radial-gradient(circle, transparent 1%, rgba(0, 92, 217, 0.2) 1%)
      center/15000%;
    cursor: pointer;
  }

  &:active {
    background-color: rgba(0, 92, 217, 0.3);
  }

  &:focus {
    background-color: rgba(0, 92, 217, 0.3);
  }
`

export const AddBlockedCategoryButtonIcon = styled(FontAwesomeIcon)`
  color: #005cd9;
  font-size: 16px;
`
